import React, { useEffect, useState } from 'react';
import { DASHBOARD_RECENT_PPR } from '../../../shared/const/Routes/statePaths';
import { getSafe } from '../../../shared/utility';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getRecentPPR } from '../../../store/actions/dashboard/dashboard';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';

const columns = onRunClick => [
  {
    field: 'PprRecipeName',
    headerName: 'PPR Name',
    flex: 2,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'PprRecipeDate',
    headerName: 'PPR Date',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'PprRecipeOwner',
    headerName: 'PPR Owner',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'run',
    headerName: 'Execute Job',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: params => (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={e => {
          e.stopPropagation();
          onRunClick(params.row);
        }}
      >
        Run
      </Button>
    ),
  },
];

const PPRTable = () => {
  const dispatch = useDispatch();
  const rows = useSelector(state => getSafe(DASHBOARD_RECENT_PPR, state));

  const [loading, setLoading] = useState(false);

  const handleRunClick = () => {};

  useEffect(() => {
    setLoading(true);
    dispatch(getRecentPPR());
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [rows]);

  return (
    <LoadingOverlay loading={loading}>
      <DataGrid
        rows={rows}
        columns={columns(handleRunClick)}
        getRowId={row => row.TargetId}
        hideFooter
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
      />
    </LoadingOverlay>
  );
};

export default PPRTable;
